import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Sparkles, ArrowLeft, Loader2 } from "lucide-react";
import { API } from "@/lib/api";
import AnswerView from "@/components/AnswerView";
import { CrossBar } from "@/components/Ornaments";

export default function SharedAnswer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [answer, setAnswer] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/questions/${id}`)
      .then(({ data }) => setAnswer(data))
      .catch(() => setNotFound(true));
  }, [id]);

  return (
    <div className="relative min-h-screen overflow-hidden bg-background">
      <div className="paper-grain pointer-events-none fixed inset-0 z-0 opacity-[0.15]" />
      <CrossBar />
      <header className="sticky top-0 z-30 border-b border-border/70 bg-background/85 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center gap-4 px-6 py-4">
          <button
            data-testid="shared-home-button"
            onClick={() => navigate("/")}
            className="flex items-center gap-2.5 font-serif text-2xl tracking-tight text-primary transition-opacity hover:opacity-70"
          >
            <img src="/logo.png" alt="AskYeshua" className="h-8 w-8" /> AskYeshua
          </button>
          <button
            data-testid="shared-ask-button"
            onClick={() => navigate("/")}
            className="ml-auto flex items-center gap-2 font-sans text-sm text-muted-foreground transition-colors hover:text-primary"
          >
            <ArrowLeft className="h-4 w-4" /> Ask your own question
          </button>
        </div>
      </header>

      <main className="relative z-10">
        {notFound ? (
          <div className="mx-auto max-w-xl px-6 py-32 text-center">
            <h1 className="font-serif text-4xl tracking-tight text-foreground">This answer could not be found</h1>
            <p className="mt-4 font-body text-lg text-muted-foreground">It may have been removed. Try asking your own question.</p>
          </div>
        ) : !answer ? (
          <div className="flex min-h-[60vh] items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <AnswerView answer={answer} />
          </motion.div>
        )}
      </main>

      <CrossBar className="pb-10 pt-6" />
    </div>
  );
}
